module.exports = __webpack_public_path__ + "img/be.80b2d2dd.svg";